import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    filters: [],
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },
};

const actions = {
    getGhlCardListIfNecessary({ commit, dispatch }, params = {}) {
        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-ghl-reimbursement');

        return axios
            .get(Laroute.route('franchise.vue.ewallet'), options)
            .then(res => {
                let data = res.data.data;

                endLoading(dispatch, 'fetch-ghl-reimbursement');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-ghl-reimbursement');
                throw err;
            });
    },

    getSearchMeta({ commit, dispatch }) {
        const route = Laroute.route(
            'franchise.report.ghl.reimbursement.search.meta',
        );

        startLoading(dispatch, 'get-ghl-reimbursement');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-ghl-reimbursement');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-ghl-reimbursement');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
